import React from 'react'

export const TooltipTitle = () => (
	<>
		<p>Если вы планируете регистрировать ООО,</p>
		<p>то укажите ИНН генерального директора.</p>
		<p>Если ИП — ИНН физического лица</p>
	</>
)
